import { useState } from 'react';
import { useFileUpload } from './useFileUpload';

interface IFIleManagement {
  documents: {
    title: string;
    texts: string[];
  };
  setActiveStep: (value: number) => void;
  reportActOnVerificationCenter: (action: string) => void;
  reportErrorDuringFileUpload: (
    errorCode: string,
    httpStatus: number,
    errorMessage: string
  ) => void;
}
export const useFileManagement = ({
  documents,
  setActiveStep,
  reportActOnVerificationCenter,
  reportErrorDuringFileUpload,
}: IFIleManagement) => {
  const [files, setFiles] = useState<FormData[]>([]);
  const [fileValue, setFileValue] = useState<null | File>(null);
  const handleReset = () => {
    setFiles([]);
    setFileValue(null);
    setActiveStep(0);
  };

  const {
    data: tokens,
    error,
    mutate,
    isPending,
  } = useFileUpload({ files, handleReset, reportErrorDuringFileUpload });

  const handleFileUpload = (file: File | undefined) => {
    if (!file) return;
    setFileValue(file);
    const fd = new FormData();

    fd.append('file', file, documents.title);

    setFiles([...files, fd]);
    reportActOnVerificationCenter(`${documents.title}_selected`);
  };

  const handleFileClear = () => {
    const clearedFiles = files.filter((file) => !file.get(documents.title));
    setFiles(clearedFiles);
  };

  return {
    files,
    setFiles,
    fileValue,
    setFileValue,
    tokens,
    mutate,
    error,
    handleReset,
    handleFileUpload,
    handleFileClear,
    isLoading: isPending,
  };
};
